import { useMemo } from 'react';
import { CategoryLeaderboardPg } from '@models/CategoryLeaderboard';
import { getSeries } from '@utils/TableUtils';
import { isKpiPercentage } from '@data-visualization/performance-segment-chart/PerformanceSegmentChartConfig';
import { GrowthTypes, KpiDropdownOption } from '@data-visualization/performance-segment-chart/Types';

export type ChartScales = { maxLeft: number; minRight: number; maxRight: number };
export type DoubleBarChartValue = {
  leftValue: number;
  rightValue: number;
  color: string;
};

export const calculateChartScales = (data: DoubleBarChartValue[]): ChartScales => {
  return data.reduce<ChartScales>(
    (acc, current) => {
      const currentRight = current.rightValue;
      const currentLeft = current.leftValue;

      acc.maxLeft = Math.max(currentLeft, acc.maxLeft);

      if (currentRight > 0) {
        acc.maxRight = Math.max(currentRight, acc.maxRight);
      } else {
        acc.minRight = Math.min(currentRight, acc.minRight);
      }

      return acc;
    },
    { maxLeft: 0, minRight: Number.MIN_VALUE, maxRight: 0 },
  );
};

export const usePerformanceSegmentMultipleChartScales = (
  categoryLeaderboardPg: CategoryLeaderboardPg[],
  selectedGrowthType: GrowthTypes,
  selectedKpi: KpiDropdownOption,
): ChartScales => {
  return useMemo<ChartScales>(() => {
    const series = getSeries(categoryLeaderboardPg, selectedKpi.value, selectedGrowthType, isKpiPercentage);

    // getSeries always return a single element
    return calculateChartScales(series[0].data);
  }, [categoryLeaderboardPg, selectedGrowthType, selectedKpi]);
};
